import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

const EditLessonDirective = angularDirectiveToReact('editLesson', { lessonId: '<' });

export function EditLessonComponent() {
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{ lessonId: string }>();

    return <EditLessonDirective key={key} {...params} />;
}
